import { render, staticRenderFns } from "./DendroGraphWidget.vue?vue&type=template&id=febf8daa&scoped=true"
import script from "./DendroGraphWidget.vue?vue&type=script&lang=js"
export * from "./DendroGraphWidget.vue?vue&type=script&lang=js"
import style0 from "./DendroGraphWidget.vue?vue&type=style&index=0&id=febf8daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febf8daa",
  null
  
)

export default component.exports